/*
  get 'api/v1/journeys' => 'journeys#api_get_all', :as => :api_journeys_get_all
  get 'api/v1/journeys/:id' => 'journeys#api_get_by_id', :as => :api_journeys_get_by_id

  get 'api/v1/journeysteps' => 'journey_steps#api_get_all', :as => :api_journeysteps_get_all
  get 'api/v1/journeysteps/:id' => 'journey_steps#api_get_by_id', :as => :api_journeysteps_get_by_id

  get 'api/v1/artwork' => 'art_pieces#api_get_all', :as => :api_artwork__get_all
  get 'api/v1/artwork/:id' => 'art_pieces#api_get_by_id', :as => :api_artwork_get_by_id

  curl --request GET \
  --url http://165.227.81.226/api/v1/journeys/ \
  --header 'content-type: application/json' \
  --header 'x-auth-account: artmuseum'

  TODO: This file is getting a bit unruly.
 */

import { 
  SET_SELECTED_JOURNEY, 
  SET_JOURNEY_NAV_STEP ,
  REQUEST_JOURNEYS,
  RECEIVE_JOURNEYS,
  SET_PERSONALIZED_NAME,
  RECEIVE_JOURNEYS_FAILED,
  RECEIVE_JOURNEY_STEPS,
  SET_JOURNEY_STEP,
  REQUEST_JOURNEY_PDF,
  SET_JOURNEY_PDF_URL,
  JOURNEY_PDF_FAILED,
  SET_KIOSK_MODE,
  JOURNEY_PRINT_FAILED,
  REQUEST_JOURNEY_PRINT,
  SET_JOURNEY_SELECT_MODAL,
} from '../constants/journey-constants'

import {
  SERVER_URL,
  ACCOUNT_ID
} from '../config'

import {
  receiveArtwork,
  resetSelectedArtwork,
  setArtworkForModal
} from './artwork-actions'

import { PRINT_SERVER } from '../config'

//import { toggleSelectJourneyModal } from './util-actions'
import fetch from 'isomorphic-fetch'

const RETRY_INTERVAL = 5000

const setSelectedJourney = (galleryId, journeyId) => {
  return dispatch => {
    dispatch({
      type: SET_SELECTED_JOURNEY,
      payload: {galleryId, journeyId}
    })
  }
}

export const setSelectedJourneyForModal = (galleryId, journeyId) => {
  return dispatch => {
    dispatch({
      type: SET_JOURNEY_SELECT_MODAL,
      payload: { galleryId, journeyId }
    })
  }
}

export const resetToJourney = (galleryId, journeyId) => {
  return dispatch => {
    dispatch(setSelectedJourney(galleryId, journeyId))
    dispatch(setJourneyNavStep(galleryId, 2))
    dispatch(setJourneyProgressStep(galleryId, 0))
    dispatch(resetSelectedArtwork(galleryId))
    dispatch(setSelectedJourneyForModal(galleryId, null))
    //dispatch(toggleSelectJourneyModal(galleryId, false))
  }
}

export const setKioskMode = (kioskMode) => {
  return dispatch => {
    dispatch({
      type: SET_KIOSK_MODE,
      payload: { kioskMode }
    })
  }
}

export const setJourneyNavStep = (galleryId, navStep) => {
  return dispatch => {
    dispatch({
      type: SET_JOURNEY_NAV_STEP,
      payload: {galleryId, navStep}
    })
  }
}

export const setJourneyProgressStep = (galleryId, journeyStep) => {
   return dispatch => {
      dispatch({
         type: SET_JOURNEY_STEP,
         payload: {
            galleryId,
            journeyStep,
         }
      })
   }
}

/* Reset back to home page
  - reset artwork selections
  - reset journey selection
  - reset ui state
  - reset PDF stuff
*/
export const resetToHome = (galleryId) => {
  return dispatch => {
    dispatch(setJourneyNavStep(galleryId, 0))
    dispatch(setSelectedJourney(galleryId, null))
    dispatch(setJourneyProgressStep(galleryId, 0))
    dispatch(resetSelectedArtwork(galleryId))
    dispatch(setArtworkForModal(galleryId, null))
    dispatch(setPersonalizedName(galleryId, ''))
    dispatch(receivePDF(galleryId, null))
    dispatch(setSelectedJourneyForModal(galleryId, null))
    // also reset ordered artwork, if relevant
    // also reset personalized name
  }
}

export const journeysFetchFailed = () => {
  return dispatch => {
    // try it again
    setTimeout(() => {
      dispatch(fetchJourneysIfNeeded())
    }, RETRY_INTERVAL)
    dispatch({
      type: RECEIVE_JOURNEYS_FAILED,
    })
  }
}



const requestAllJourneys = () => {
  return {
    type: REQUEST_JOURNEYS
  }
}

// handle the initial API call which handles journeys, steps, and artwork
const receiveAllJourneys = (json) => {
  return dispatch => {
    dispatch({
      type: RECEIVE_JOURNEYS,
      payload: {
        data: json['journeys'],
        receivedAt: Date.now()
      }
    })

    dispatch({
      type: RECEIVE_JOURNEY_STEPS,
      payload: {
        data: json['journey_steps'],
        receivedAt: Date.now()
      }
    })

    dispatch(receiveArtwork(json['artwork']))
  }
}

/* PDF Generation */
export const pdfFetchFailed = (galleryId) => {
  return dispatch => {
    dispatch({
      type: JOURNEY_PDF_FAILED,
      payload: { galleryId }
    })
  }
}

const requestPDF = (galleryId) => {
  return dispatch => {
    dispatch({
      type: REQUEST_JOURNEY_PDF,
      payload: { galleryId }
    })
  }
}

const requestPDFPrint = (galleryId) => {
  // REQUEST_JOURNEY_PRINT
  return dispatch => {
    dispatch({
      type: REQUEST_JOURNEY_PRINT,
      payload: { galleryId }
    })
  }
}

// also used with pdfURL ==> null to reset
export const receivePDF = (galleryId, pdfUrl) => {
  return dispatch => {
    dispatch({
      type: SET_JOURNEY_PDF_URL,
      payload: {
        pdfUrl,
        galleryId
      }
    })
  }
}

const fetchPDFUrl = (galleryId, journeyId, selectedArtworkIds, personalizedName) => {
  return dispatch => {
    dispatch(requestPDF(galleryId))

    // build up the request object
    let form = new FormData();
    form.append("pdf[journey_id]", journeyId)
    selectedArtworkIds.forEach(item => {
      form.append("pdf[art_piece_ids][]", item)
    })
    form.append("pdf[custom_name]", personalizedName) /* deprecated */
    form.append("pdf[personalized_name]", personalizedName)
    form.append("pdf[page_size]", "A3") /* 11x14: A3 -- leave blank (or "letter") for default */
    return fetch(`${SERVER_URL}/pdfs`, {
      method: 'post',
      headers: {
        'x-auth-account': ACCOUNT_ID
      },
      body: form,
      redirect: 'error', // error on redirect response (ex: backend has auth protection)
    })
    .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response
    })
    .then(response => response.json())
    .then(json => dispatch(receivePDF(galleryId, json.url)))
    .catch(error => dispatch(pdfFetchFailed(galleryId)))
  }
}

function shouldFetchPDFURL(state, galleryId) {
  return (state.journeyState.getIn([galleryId, 'pdfFile', 'isFetching']) === false)
}

export const fetchPDFURLIfNeeded = (galleryId, journeyId, selectedArtworkIds, personalizedName) => {
  // for now always fetch journeys
  return (dispatch, getState) => {
    if (shouldFetchPDFURL(getState(), galleryId)) {
      return dispatch(fetchPDFUrl(galleryId, journeyId, selectedArtworkIds, personalizedName))
    }
  }
}

/* Print PDF */
//JOURNEY_PRINT_FAILED
export const pdfPrintFailed = (galleryId) => {
  return dispatch => {
    dispatch({
      type: JOURNEY_PRINT_FAILED,
      payload: { galleryId }
    })
  }
}

export const printPDF = (pdfUrl, galleryId) => {
  return dispatch => {
    dispatch(requestPDFPrint(galleryId))
    return fetch(`${PRINT_SERVER}/print`, {
      headers: {'content-type': 'application/json'}, 
      method: 'POST', 
      body: JSON.stringify({url: pdfUrl})})
      .then(response => response.json)
      .then(response => {
        if (response.error) {
          // error handling
          dispatch(pdfPrintFailed(galleryId))
          console.log(`--> print failed with error ${response.error}`)
        } else {
          // hey it went well
          dispatch(setJourneyNavStep(galleryId, 5))
          console.log(`--> printed ${pdfUrl} successfully`)
        }
      })
      .catch(error => dispatch(pdfPrintFailed(galleryId)))
  }
}

/* Journey API Fetch */
const fetchJourneys = () => {
  return dispatch => {
    dispatch(requestAllJourneys())
    return fetch(`${SERVER_URL}/api/v1/journeys/`, {
      headers: {
        'content-type': 'application/json',
        'x-auth-account': ACCOUNT_ID
      }
    })
    .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response
    })
    .then(response => response.json())
    .then(json => dispatch(receiveAllJourneys(json)))
    .catch(error => dispatch(journeysFetchFailed()))
  }
}

function shouldFetchJourneys(state) {
  return (state.journey.getIn(['isFetching', 'journeys']) === false)
}

export const fetchJourneysIfNeeded = () => {
  // for now always fetch journeys
  return (dispatch, getState) => {
    if (shouldFetchJourneys(getState())) {
      return dispatch(fetchJourneys())
    }
  }
}

export const setPersonalizedName = (galleryId, personalizedName) => {
  return dispatch => {
    dispatch({
      type: SET_PERSONALIZED_NAME,
      payload: {galleryId, personalizedName}
    })
  }
}

/*
export const requestJourneyById = (journeyId) => {
  return dispatch => {
    dispatch({
      type: REQUEST_JOURNEYS,
      payload: {journeyId}
    })
  }
} */



// WEBPACK FOOTER //
// ./src/actions/journey-actions.js